import React from 'react';
import { BuyForm } from '../GiftPage';
import { trackEvent } from '../utils/analytics';

// F-13 — the in-app "warm path" gift sheet. A quiet overlay that reuses the EXISTING BuyForm
// (embedded mode = just the checkout card, no hero/testimonials/FAQ) with one framing sentence
// above it. Same submit handler, same Stripe redirect. Fires gift_sheet_opened on open.

export default function GiftSheet({ open, onClose }) {
  React.useEffect(() => {
    if (open) {
      try { trackEvent('gift_sheet_opened', {}); } catch (e) { /* telemetry best-effort */ }
    }
  }, [open]);

  if (!open) return null;

  return (
    <div
      data-testid="gift-sheet"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(44,36,32,0.6)',
        backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
        padding: '24px 16px', overflowY: 'auto',
      }}>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 18, maxWidth: 520, width: '100%', margin: 'auto', boxShadow: '0 12px 40px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 8px 0' }}>
          <button onClick={onClose} aria-label="Close" style={{ minHeight: 44, minWidth: 44, background: 'none', border: 'none', fontSize: '1.4rem', color: '#9a8570', cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ padding: '0 22px 24px' }}>
          {/* One framing sentence. The price (with the cap-aware sale) lives in the BuyForm below —
              F-163-GIFT: no separate static price here, so the sheet never shows two prices at once. */}
          <p style={{ fontFamily: "'Lora', serif", fontSize: '1.05rem', lineHeight: 1.5, color: '#2a2520', textAlign: 'center', margin: '4px 0 18px' }}>
            A prepaid Talebound for someone you love. They tell their stories; we make the real book.
          </p>
          <BuyForm embedded />
        </div>
      </div>
    </div>
  );
}
